import 'core-js/modules/es.array.concat';
import 'core-js/modules/es.array.filter';
import 'core-js/modules/es.array.includes';
import 'core-js/modules/es.array.map';
import 'core-js/modules/es.object.assign';
import 'core-js/modules/es.object.entries';
import 'core-js/modules/es.object.keys';
import 'core-js/modules/es.object.values';
import 'core-js/modules/es.regexp.exec';
import 'core-js/modules/es.string.includes';
import 'core-js/modules/es.string.replace';
import 'core-js/modules/es.string.split';
import 'core-js/modules/web.dom-collections.for-each';
import 'regenerator-runtime/runtime';
import { isWorldReadyInstance, Region } from '@paypalcorp/worldready-core';
import { assertType, assert, assertRange } from 'yaassertion';
import Cldr from 'cldrjs/dist/cldr';

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _createForOfIteratorHelperLoose(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (t) return (t = t.call(r)).next.bind(t);
  if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
    t && (r = t);
    var o = 0;
    return function () {
      return o >= r.length ? {
        done: !0
      } : {
        done: !1,
        value: r[o++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function (t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine(u), _regeneratorDefine(u, o, "Generator"), _regeneratorDefine(u, n, function () {
    return this;
  }), _regeneratorDefine(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function () {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine = function (e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      function o(r, n) {
        _regeneratorDefine(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      }
      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine(e, r, n, t);
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

var getMissingMetadataError = function getMissingMetadataError(path) {
  var message = "Missing WorldReady metadata, please refer to https://github.paypal.com/pages/Globalization-R/worldready-js/docs/about-load-worldready-data.html";
  if (path) {
    message += "\nPath: " + path;
  }
  return new Error(message);
};
function validateCldr(path, value, options) {
  if (options === void 0) {
    options = {
      skip: []
    };
  }
  var skipBoolean = options.skip.some(function (regex) {
    return regex.test(path);
  });
  if (skipBoolean) {
    return;
  }
  if (value === undefined) {
    throw getMissingMetadataError(path);
  }
}
var ADDRESS_LABEL_DISPLAY_NAME_TYPES = {
  COARSE_ADDRESS: "coarseAddress",
  PORTABLE_ADDRESS: "portableAddress",
  PORTABLE_ADDRESS_VALUES: "portableAddressValues",
  COARSE_ADDRESS_VALUES: "coarseAddressValues"
};
var DISPLAY_NAME_TYPES = Object.assign({}, ADDRESS_LABEL_DISPLAY_NAME_TYPES, {
  PERSON_NAME: "personName",
  REGION: "region",
  LANGUAGE: "language",
  DATE_TIME_FIELD: "dateTimeField",
  CURRENCY: "currency",
  MONTH: "month",
  DAY: "day",
  TERRITORY_NAME_SORT_KEY: "territoryNameSortKey",
  CURRENCY_NAME_SORT_KEY: "currencyNameSortKey"
});
var ENVIRONMENT = {
  PRODUCTION: "production"
};
var MESSAGE_MISSING = "\uE007\uE007";
var countryAliasMapping = {
  C2: "CN",
  UK: "GB"
};
function getResolvedRegion(region) {
  return countryAliasMapping[region] || region;
}

// Code borrowed from Cldrjs and adapted.
// TODO Improve Cldrjs API and make export() available.
// Note: Cldrjs unresolved module should resolve data when exporting.
var cldrParentLookup = function cldrParentLookup(cldr, locale) {
  if (locale === "root") {
    return;
  }

  // First, try to find parent on supplemental data.
  var parent = cldr.get(["supplemental/parentLocales/parentLocale", locale]);
  if (parent) {
    return parent;
  }

  // Or truncate locale.
  parent = locale.substr(0, locale.lastIndexOf("-"));
  if (!parent) {
    return "root";
  }
  return parent;
};
var _inheritanceChain = /*#__PURE__*/_regenerator().m(function _inheritanceChain(cldr, locale) {
  return _regenerator().w(function (_context) {
    while (1) switch (_context.n) {
      case 0:
        _context.n = 1;
        return locale;
      case 1:
        if (locale = cldrParentLookup(cldr, locale)) {
          _context.n = 0;
          break;
        }
      case 2:
        return _context.a(2);
    }
  }, _inheritanceChain);
});
function inheritanceChain(cldr, locale) {
  return _inheritanceChain(cldr, locale);
}
var DisplayNames = /*#__PURE__*/function () {
  /**
   * @param {Object} worldReady
   * @param {Object} options
   * @param {String} options.type
   */
  function DisplayNames(worldReady, options) {
    var _this = this;
    if (options === void 0) {
      options = {};
    }
    // Error Checks
    if (process.env.NODE_ENV !== ENVIRONMENT.PRODUCTION) {
      assert(isWorldReadyInstance(worldReady), "WorldReady object missing.");
      assertType(options.type, "options.type", ["string"]);
      assertRange(options.type, Object.values(DISPLAY_NAME_TYPES), "options.type must be one of the value from " + Object.values(DISPLAY_NAME_TYPES));
      if (options.fallback) {
        assertRange(options.fallback, ["code", "none"], "options.fallback must be 'none', or 'code'");
      }
      var _options = options,
        type = _options.type;
      if (type === DISPLAY_NAME_TYPES.PERSON_NAME) {
        Region.assertType(options.nameRegion, "options.nameRegion");
      }
      if (Object.values(ADDRESS_LABEL_DISPLAY_NAME_TYPES).includes(type)) {
        Region.assertType(options.addressRegion, "options.addressRegion");
      }
      if (type === DISPLAY_NAME_TYPES.PORTABLE_ADDRESS_VALUES) {
        assertRange(options.element, ["adminArea1", "adminArea2"], "options.element must be 'adminArea1' or 'adminArea2'");
      }
      if (type === DISPLAY_NAME_TYPES.COARSE_ADDRESS_VALUES) {
        assertRange(options.element, ["state", "city"], "options.element must be 'state' or 'city'");
      }
      if (type === DISPLAY_NAME_TYPES.DATE_TIME_FIELD) {
        assertRange(options.style, ["long", "short", "narrow", "abbreviated"], "options.style must be 'long', 'short', 'narrow' or 'abbreviated'");
      }
      if (type === DISPLAY_NAME_TYPES.MONTH) {
        assertRange(options.style, ["wide", "narrow", "abbreviated"], "options.style must be 'wide', 'narrow' or 'abbreviated'");
      }
      if (type === DISPLAY_NAME_TYPES.DAY) {
        assertRange(options.style, ["wide", "narrow", "short", "abbreviated"], "options.style must be 'wide', 'narrow', 'short' or 'abbreviated'");
      }
    }
    var region = options.nameRegion || options.addressRegion;
    if (region) {
      region = Region.getRegionString(region);
    }
    var _options2 = options,
      element = _options2.element,
      style = _options2.style;
    var cldr = worldReady.globalize.cldr;
    this.fallback = options.fallback || "code";
    this.type = options.type;
    if (this.type === DISPLAY_NAME_TYPES.COARSE_ADDRESS_VALUES) {
      element = element === "state" ? "adminArea1" : "adminArea2";
    }
    var cldrDataMarketOverride, aux, regionalLabels;
    // ../metadata/metadata-v2.js ==> injects WorldReady's name & address metadata into CLDR metadata
    switch (options.type) {
      case DISPLAY_NAME_TYPES.PERSON_NAME:
        this.cldrData = Object.assign({}, cldr.main("peopleNames/00"), {}, cldr.main(["peopleNames", region]));
        break;
      case DISPLAY_NAME_TYPES.REGION:
        this.cldrData = Object.assign({}, cldr.main("localeDisplayNames/territories"));
        cldrDataMarketOverride = Object.assign({}, cldr.main(["marketOverrides", worldReady.region, "localeDisplayNames/territories"]));
        Object.assign(this.cldrData, cldrDataMarketOverride);
        break;
      case DISPLAY_NAME_TYPES.LANGUAGE:
        this.cldrData = Object.assign({}, cldr.main("localeDisplayNames/languages"));
        break;
      case DISPLAY_NAME_TYPES.MONTH:
        this.cldrData = Object.assign({}, cldr.main(["dates/calendars/gregorian/months", "stand-alone", style]));
        break;
      case DISPLAY_NAME_TYPES.DAY:
        {
          this.cldrData = Object.assign({}, cldr.main(["dates/calendars/gregorian/days", "stand-alone", style]));
          break;
        }
      case DISPLAY_NAME_TYPES.CURRENCY:
        {
          this.cldrData = {};
          Object.entries(cldr.main("numbers/currencies")).forEach(function (_ref) {
            var field = _ref[0],
              value = _ref[1];
            _this.cldrData[field] = value.displayName;
          });
        }
        break;
      case DISPLAY_NAME_TYPES.DATE_TIME_FIELD:
        aux = style === "long" ? "" : "-" + style;
        {
          this.cldrData = {};
          Object.entries(cldr.main("dates/fields")).filter(function (_ref2) {
            var field = _ref2[0];
            return field === "" + field.split("-")[0] + aux;
          }).forEach(function (_ref3) {
            var field = _ref3[0],
              value = _ref3[1];
            _this.cldrData[field.split("-")[0]] = value.displayName;
          });
        }
        break;
      case DISPLAY_NAME_TYPES.COARSE_ADDRESS:
        regionalLabels = cldr.main(["addresses/coarse", region]);
        if (!regionalLabels) {
          this.cldrData = {};
          break;
        }
        this.cldrData = regionalLabels === MESSAGE_MISSING ? Object.assign({}, cldr.main("addresses/coarse/00")) : Object.assign({}, cldr.main("addresses/coarse/00"), {}, regionalLabels);
        break;
      case DISPLAY_NAME_TYPES.PORTABLE_ADDRESS:
        regionalLabels = cldr.main(["addresses/portable", region]);
        if (!regionalLabels) {
          this.cldrData = {};
          break;
        }
        this.cldrData = regionalLabels === MESSAGE_MISSING ? Object.assign({}, cldr.main("addresses/portable/00")) : Object.assign({}, cldr.main("addresses/portable/00"), {}, regionalLabels);
        break;
      // for coarse and portable value we need to get either adminArea1 or adminArea2
      case DISPLAY_NAME_TYPES.COARSE_ADDRESS_VALUES:
      case DISPLAY_NAME_TYPES.PORTABLE_ADDRESS_VALUES:
        // Sanitize path by escaping slashes "/", e.g.: "bar/baz" becomes "bar_baz"
        element.replace(/[/]/g, "_");
        this.cldrData = Object.assign({}, cldr.main(["addresses/" + element, region]));
        break;
      case DISPLAY_NAME_TYPES.TERRITORY_NAME_SORT_KEY:
        this.cldrData = Object.assign({}, cldr.main("localeDisplayNames/territoryNameSortKey"));
        cldrDataMarketOverride = Object.assign({}, cldr.main(["marketOverrides", region, "localeDisplayNames/territoryNameSortKey"]));
        Object.assign(this.cldrData, cldrDataMarketOverride);
        break;
      case DISPLAY_NAME_TYPES.CURRENCY_NAME_SORT_KEY:
        this.cldrData = Object.assign({}, cldr.main("numbers/currencyNameSortKey"));
        break;
    }
    if (!Object.keys(this.cldrData).length) {
      validateCldr();
    }
  }

  /**
   * Check if 'properties' are valid based on the DisplayNames object's type.
   * If they are, return translated array. If they are not, return error.
   * @param {Array} properties
   * @returns {Array}
   */
  var _proto = DisplayNames.prototype;
  _proto.select = function select(properties) {
    var _this2 = this;
    // Error check
    if (process.env.NODE_ENV !== ENVIRONMENT.PRODUCTION) {
      assertType(properties, "properties", ["array", "string"]);
    }
    if (Array.isArray(properties)) {
      return properties.map(function (prop) {
        return _this2.select(prop);
      });
    }
    var prop = getResolvedRegion(properties);
    var value = this.cldrData[prop] === null || this.cldrData[prop] === MESSAGE_MISSING ? null : this.cldrData[prop];
    // Fallback logic to support CLDR v43 language names
    if (this.type === DISPLAY_NAME_TYPES.LANGUAGE && !value) {
      for (var _iterator = _createForOfIteratorHelperLoose([].concat(inheritanceChain(new Cldr(prop), prop)).reverse()), _step; !(_step = _iterator()).done;) {
        var lang = _step.value;
        value = this.cldrData[lang] === null || this.cldrData[lang] === MESSAGE_MISSING ? null : this.cldrData[lang];
        if (value) {
          break;
        }
      }
    }
    // special case for territory/currency name sort key to retrun 0
    if (value === 0) {
      return 0;
    }
    return value || (this.fallback === "code" ? prop : undefined);
  };
  return DisplayNames;
}();

export { DisplayNames };
